import React from 'react';

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="space-y-2">
    <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
    <div className="text-gray-600 leading-relaxed">{children}</div>
  </div>
);

const PrivacyPolicyPage: React.FC = () => (
  <div className="min-h-screen bg-[#FCFCFC] py-12 px-4 md:px-20">
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Privacy Policy</h1>
      <p className="text-gray-400 text-sm mb-8">Last updated: August 2026</p>
      <div className="bg-white rounded-xl shadow p-8 space-y-6">
        <Section title="1. Information We Collect">
          <p>We collect information you provide when creating an account, placing orders, or contacting us — including your name, email address, phone number, and delivery address.</p>
        </Section>
        <Section title="2. How We Use Your Information">
          <p>We use your information to process orders, send order updates, improve our services, and communicate offers. We do not sell your personal data to third parties.</p>
        </Section>
        <Section title="3. Data Security">
          <p>We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.</p>
        </Section>
        <Section title="4. Cookies">
          <p>Our website uses cookies to enhance your browsing experience. You can disable cookies in your browser settings, though some features may not function properly.</p>
        </Section>
        <Section title="5. Third-Party Services">
          <p>We may use third-party services for payment processing and analytics. These services have their own privacy policies.</p>
        </Section>
        <Section title="6. Contact Us">
          <p>For any privacy-related queries, contact us at <span className="text-[#DAA520]">sastadealpvt@gmail.com</span></p>
        </Section>
      </div>
    </div>
  </div>
);

export default PrivacyPolicyPage;
